define('views/components/welcome_message/welcome_messages',['require','backbone','views/components/welcome_message/welcome_message','text!templates/components/welcome_message/welcome_messages.html'],function(require){

    var Backbone = require('backbone');
    var ChildView = require('views/components/welcome_message/welcome_message');

    var temp = require("text!templates/components/welcome_message/welcome_messages.html");

    return Backbone.Marionette.CompositeView.extend({
        template: _.template(temp),
        tagName: 'div',
        childViewContainer: '.welcome-messages-holder',
        childView: ChildView,

        initialize: function () {
            this.listenTo(this.collection, 'fetch_complete', this._onFetch);
            this.collection.fetch();
        },

        _onFetch: function () {
            this.render();
        }
    });
});

